package one.healthium.domain.user.models


import kotlinx.serialization.Serializable

@Serializable
data class UserPurchasesModel(
    val subscription: SubscriptionStatus,
    val purchaseType: String?,
    val subscriptionId: String?,
) {
    val purchaseSource by lazy {
        val normalisedPurchaseType = purchaseType?.lowercase()
        when {
            normalisedPurchaseType == "android" || normalisedPurchaseType == "apple" -> PurchaseSource.Mobile
            normalisedPurchaseType?.isNotEmpty() == true -> PurchaseSource.Web
            else -> PurchaseSource.None
        }
    }
}

@Serializable
enum class SubscriptionStatus {
    Active,
    Inactive
}

enum class PurchaseSource {
    Mobile,
    Web,
    None
}